<template>
  <div>
    <hbt-capa/>
    <hbt-frases/>
    <hbt-beneficios/>
    <hbt-turmas-anteriores/>
    <hbt-sobre/>
    <hbt-depoimentos/>
    <hbt-inspiracao/>
    <hbt-inscricao :endtime="endtime" />
    <hbt-cta/>
    <hbt-rodape/>
  </div>
</template>

<script>
import HbtCapa from '../components/Capa';
import HbtFrases from '../components/Frases';
import HbtBeneficios from '../components/Beneficios';
import HbtTurmasAnteriores from '../components/TurmasAnteriores';
import HbtSobre from '../components/Sobre';
import HbtDepoimentos from '../components/Depoimentos';
import HbtInspiracao from '../components/Inspiracao';
import HbtInscricao from '../components/Inscricao';
import HbtCta from '../components/Cta';
import HbtRodape from '../components/Rodape';

export default {
  name: 'App',
  props:['endtime'],
  components: {
    HbtCapa,
    HbtFrases,
    HbtBeneficios,
    HbtTurmasAnteriores,
    HbtSobre,
    HbtDepoimentos,
    HbtInspiracao,
    HbtInscricao,
    HbtCta,
    HbtRodape
  },

  data: () => ({
    //
  }),
  mounted () {
  }
  
};
</script>